import ReactMarkdown from 'react-markdown';
import { SpecialComponents } from 'react-markdown/lib/ast-to-react';
import { NormalComponents } from 'react-markdown/lib/complex-types';
import rehypeRaw from 'rehype-raw';
import remarkBreaks from 'remark-breaks';
import remarkGfm from 'remark-gfm';

interface Props {
  markdown: string;
  components?: Partial<Omit<NormalComponents, keyof SpecialComponents> & SpecialComponents> | undefined;
}
const ContentMarkDown = ({ markdown, components }: Props) => {
  return (
    <ReactMarkdown rehypePlugins={[rehypeRaw]} remarkPlugins={[remarkGfm, remarkBreaks]} components={components}>
      {markdown}
    </ReactMarkdown>
  );
};

export default ContentMarkDown;
